<script setup>
defineProps(['model'])
const { showFooterForm } = useLayoutFlags()
showFooterForm.value = true
</script>

<template>
  <div class="home-page">
    <HomePageHeroBlock
      :color="model.heroBgColor?.value"
      :title="model.heroTitle?.value"
      :body="model.heroBody?.value"
      :link-text="model.heroLink?.value?.text"
      :link-url="model.heroLink?.value?.href"
      :image="model.aprimoHeroImage?.url || '/images/home-hero.jpg'"
      :image-alt-text="model.heroDesktopImageAltText?.value || model.heroMobileImageAltText?.value || 'Hero image'"
      :image-width="model.aprimoHeroImage?.width"
      :image-height="model.aprimoHeroImage?.height"
      :image-mobile="model.aprimoHeroMobileImage?.url || '/images/home-hero-sm.jpg'"
      :image-mobile-width="model.aprimoHeroMobileImage?.width"
      :image-mobile-height="model.aprimoHeroMobileImage?.height"
      :overlap="model.heroAllowOverlap?.value"
      :trustpilot-area="model.trustpilotArea?.expandedValue"
    />
    <div class="container-fluid">
      <div class="page-block-area flex flex-col items-center w-full">
        <GenericsContentArea
          v-if="model.pageBlockArea?.expandedValue"
          :model="model.pageBlockArea.expandedValue"
        />
      </div>
    </div>
  </div>
</template>
